<div class="container">

  <div id="loginbox" class="mainbox col-md-6 col-sm-6 mx-auto">

    <div class="row">
      <div class="iconmelon">
        <svg viewBox="0 0 32 32">
          <g filter="">
            <use xlink:href="#git"></use>
          </g>
        </svg>
      </div>
    </div>

    <div class="panel panel-default">
      <div class="panel-heading">
        <div class="panel-title text-center">Airtotaal</div>
      </div>

      <div class="panel-body">

        <form name="form" id="form" class="form-horizontal" enctype="multipart/form-data"
              (ngSubmit)="f.form.valid && login()" #f="ngForm">

          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-user"></i></span>
            <input type="email" id="user" class="form-control" placeholder="Email address" [(ngModel)]="model.username"
                   name="username" placeholder="User" required autofocus #username="ngModel">
          </div>

          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-lock"></i></span>
            <input type="password" id="password" placeholder="Password" class="form-control"
                   [(ngModel)]="model.password"
                   name="password" placeholder="Password" #password="ngModel" required>
          </div>

          <div class="input-group">
            <!-- Button -->
            <div class="col-sm-12 controls">
              <pre class="alert alert-danger" *ngIf="error">{{error}}</pre>
              <button type="submit" class="btn btn-primary pull-right"><i class="fa fa-sign-in"></i> Log in
              </button>
            </div>
          </div>

        </form>

      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/pages/login/login.html